import axiosClient from '../../configs/axios.js';

class MRRepot {
  async getMRrepotlist({ entry_date, plant_id }) {
    try {
      const login_details = sessionStorage.getItem("loginUser");
      const userD = JSON.parse(login_details);
      const userInfo = userD?.result?.userInfo;
        //  const unit_id = userInfo?.depot_id || userInfo?.plant_id ;

      // Construct the query parameters
      const queryParams = new URLSearchParams();
      queryParams.append('date', entry_date);
      if (plant_id) {
        queryParams.append('plant_id', plant_id);
      }

      // Make the API call
      const response = await axiosClient.get(
        `/reports/CylProduction?${queryParams.toString()}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }
}

export default new MRRepot();